// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DocumentEditorDetailFragmentDoc } from '../../../fragments/circularFragments.generated';
import { DevContractHeader_ItemTemplateCostUpdateFragmentDoc } from '../procurement/DevelopmentContractPage.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type SavePriceAgreementDocumentMutationVariables = Types.Exact<{
  input: Types.SaveDocumentInput;
}>;


export type SavePriceAgreementDocumentMutation = { __typename?: 'Mutation', saveDocuments: { __typename?: 'SaveDocumentsResult', documents: Array<{ __typename?: 'Document', name: string, sizeInBytes: number, attachOn: Array<Types.DocumentAttachmentPlace>, id: string, category: Types.DocumentCategory, createdAt: Types.Scalars['DateTime']['input'], displayName: string, homeownerVisible: boolean, isDeleted?: boolean | null | undefined, isFavorited: boolean, issuanceDate?: Types.Scalars['Date']['input'] | null | undefined, owner?:
        | { __typename?: 'HomeownerContract' }
        | { __typename?: 'HomeownerContractChangeOrder' }
        | { __typename?: 'Commitment' }
        | { __typename?: 'CommitmentChangeOrder', id: string, statusText: string, changeOrderStatus: Types.CommitmentStatus }
        | { __typename?: 'DevelopmentCommitment', id: string, statusText: string, developentCommitmentStatus: Types.CommitmentStatus }
        | { __typename?: 'InvoiceDocument' }
        | { __typename?: 'Development' }
        | { __typename?: 'PlanPackage' }
        | { __typename?: 'StandaloneProject' }
        | { __typename?: 'Region' }
        | { __typename?: 'Market' }
        | { __typename?: 'Community' }
        | { __typename?: 'Subdivision' }
        | { __typename?: 'Lot' }
        | { __typename?: 'Structure' }
        | { __typename?: 'Unit' }
        | { __typename?: 'BidContractRevision', id: string, signedOn?: Types.Scalars['Date']['input'] | null | undefined, revisionStatus: { __typename?: 'BidContractRevisionStatusDetail', code: Types.BidContractRevisionStatus, name: string }, itemTemplateCostUpdates: Array<{ __typename?: 'ItemTemplateCostUpdate', id: string, completed: boolean, itemTemplate: { __typename?: 'ItemTemplate', id: string, displayName: string } }> }
        | { __typename?: 'LienWaiver' }
        | { __typename?: 'ChangeEvent' }
       | null | undefined, canArchive: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, categoryDetail?: { __typename?: 'DocumentCategoryDetail', name: string, code: Types.DocumentCategory } | null | undefined, followers: Array<{ __typename?: 'InternalUser', id: string }>, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }, assets: Array<{ __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }>, createdBy: { __typename?: 'User', id: string, name: string }, tasks: Array<{ __typename?: 'Task', id: string }>, associatedProjects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      >, parent:
        | { __typename?: 'Development', id: string, name: string, cohorts?: Array<{ __typename?: 'Cohort', id: string, name: string, projects: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string }
              | { __typename?: 'Region', id: string, name: string }
              | { __typename?: 'Market', id: string, name: string }
              | { __typename?: 'Community', id: string, name: string }
              | { __typename?: 'Subdivision', id: string, name: string }
              | { __typename?: 'Lot', id: string, name: string }
              | { __typename?: 'Structure', id: string, name: string }
              | { __typename?: 'Unit', id: string, name: string }
            > }> | null | undefined }
        | { __typename?: 'PlanPackage', id: string }
        | { __typename?: 'StandaloneProject', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          > }
        | { __typename?: 'Region', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          > }
        | { __typename?: 'Market', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          > }
        | { __typename?: 'Community', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          > }
        | { __typename?: 'Subdivision', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          > }
        | { __typename?: 'Lot', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          > }
        | { __typename?: 'Structure', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          > }
        | { __typename?: 'Unit', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          > }
      , documentType: { __typename?: 'DocumentTypeDetail', code: Types.DocumentType, name: string, systemControlled: boolean }, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }> } };

export type PriceAgreementOwner_ChangeOrderFragment = { __typename?: 'CommitmentChangeOrder', id: string, statusText: string, changeOrderStatus: Types.CommitmentStatus };

export type PriceAgreementOwner_BidContractRevisionFragment = { __typename?: 'BidContractRevision', id: string, signedOn?: Types.Scalars['Date']['input'] | null | undefined, revisionStatus: { __typename?: 'BidContractRevisionStatusDetail', code: Types.BidContractRevisionStatus, name: string }, itemTemplateCostUpdates: Array<{ __typename?: 'ItemTemplateCostUpdate', id: string, completed: boolean, itemTemplate: { __typename?: 'ItemTemplate', id: string, displayName: string } }> };

export type PriceAgreementOwner_DevelopmentCommitmentFragment = { __typename?: 'DevelopmentCommitment', id: string, statusText: string, developentCommitmentStatus: Types.CommitmentStatus };

export const PriceAgreementOwner_ChangeOrderFragmentDoc = gql`
    fragment PriceAgreementOwner_ChangeOrder on CommitmentChangeOrder {
  id
  changeOrderStatus: status
  statusText
}
    `;
export const PriceAgreementOwner_BidContractRevisionFragmentDoc = gql`
    fragment PriceAgreementOwner_BidContractRevision on BidContractRevision {
  id
  revisionStatus: status {
    code
    name
  }
  itemTemplateCostUpdates {
    ...DevContractHeader_ItemTemplateCostUpdate
  }
  signedOn
}
    ${DevContractHeader_ItemTemplateCostUpdateFragmentDoc}`;
export const PriceAgreementOwner_DevelopmentCommitmentFragmentDoc = gql`
    fragment PriceAgreementOwner_DevelopmentCommitment on DevelopmentCommitment {
  id
  developentCommitmentStatus: status
  statusText
}
    `;
export const SavePriceAgreementDocumentDocument = gql`
    mutation SavePriceAgreementDocument($input: SaveDocumentInput!) {
  saveDocuments(input: {documents: [$input]}) {
    documents {
      ...DocumentEditorDetail
      owner {
        ...PriceAgreementOwner_ChangeOrder
        ...PriceAgreementOwner_BidContractRevision
        ...PriceAgreementOwner_DevelopmentCommitment
      }
    }
  }
}
    ${DocumentEditorDetailFragmentDoc}
${PriceAgreementOwner_ChangeOrderFragmentDoc}
${PriceAgreementOwner_BidContractRevisionFragmentDoc}
${PriceAgreementOwner_DevelopmentCommitmentFragmentDoc}`;
export type SavePriceAgreementDocumentMutationFn = Apollo.MutationFunction<SavePriceAgreementDocumentMutation, SavePriceAgreementDocumentMutationVariables>;

/**
 * __useSavePriceAgreementDocumentMutation__
 *
 * To run a mutation, you first call `useSavePriceAgreementDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePriceAgreementDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePriceAgreementDocumentMutation, { data, loading, error }] = useSavePriceAgreementDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSavePriceAgreementDocumentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SavePriceAgreementDocumentMutation, SavePriceAgreementDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SavePriceAgreementDocumentMutation, SavePriceAgreementDocumentMutationVariables>(SavePriceAgreementDocumentDocument, options);
      }
export type SavePriceAgreementDocumentMutationHookResult = ReturnType<typeof useSavePriceAgreementDocumentMutation>;
export type SavePriceAgreementDocumentMutationResult = Apollo.MutationResult<SavePriceAgreementDocumentMutation>;
export type SavePriceAgreementDocumentMutationOptions = Apollo.BaseMutationOptions<SavePriceAgreementDocumentMutation, SavePriceAgreementDocumentMutationVariables>;